/**
 * filterHoursByPeriod.js
 *
 * Given the raw rows from the backend (each row has hours_by_day: { "2025-01-01": X, "2025-01-02": Y, ... })
 * and a periodFrom/periodTo date range, returns a NEW hoursData array where
 * total_horas = sum of only the days that fall within [periodFrom, periodTo].
 *
 * If a row has NO hours_by_day (old backend or Billable-only), falls back to total_horas as-is.
 * This guarantees 100% backward compatibility with the annual view.
 */

/**
 * @param {Array}  rows        - internals.rows or externals.rows from backend
 * @param {string} periodFrom  - "YYYY-MM-DD"
 * @param {string} periodTo    - "YYYY-MM-DD"
 * @returns {Array}            - same rows but with total_horas recalculated for the period
 */
export function filterHoursByPeriod(rows, periodFrom, periodTo) {
  const from = new Date(periodFrom);
  const to   = new Date(periodTo);

  return rows.map((row) => {
    const byDay = row.hours_by_day;

    // Fallback: no daily breakdown available → use total_horas unchanged
    if (!byDay || Object.keys(byDay).length === 0) {
      return row;
    }

    // Sum only days that fall within [from, to]
    let filtered = 0;
    for (const [dateStr, hours] of Object.entries(byDay)) {
      const dayDate = new Date(dateStr);
      if (dayDate >= from && dayDate <= to) {
        filtered += Number(hours) || 0;
      }
    }

    return { ...row, total_horas: filtered };
  });
}